// src/features/projects/hooks/useProgram.js

import { useMemo } from "react";

export default function useProgram({ programs, programSlug }) {

  const program = useMemo(() => {

    if (!programs || programs.length === 0) return null;

    return programs.find(
      p => p.programSlug === programSlug
    );

  }, [programs, programSlug]);

  return { program };
}